'use client'
import React from 'react'
import { motion } from 'motion/react'
import { ExhibitionPageDetailsFragment } from '@/gql/generated/graphql'
import { JumboText } from 'design-configuration/components'
import { exhibitionTransition } from '../[slug]/components/header'
import { IskraWork } from './works/iskra'
import { LarsWork } from './works/lars'
import { ZachWork } from './works/zach'

export const GroupExhibitionQ42024WorksSection = ({
  exhibition
}: {
  exhibition: ExhibitionPageDetailsFragment
}): React.ReactElement => {
  return (
    <div className="w-full">
      {/* title and subtitle */}
      <motion.div
        className="px-md pb-xl max-w-[1016px]"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={exhibitionTransition}
        viewport={{ once: true, amount: 0.5 }}
      >
        <JumboText className="font-medium">The works</JumboText>
      </motion.div>
      <div className="mb-[80px] flex w-full flex-col gap-y-[80px] lg:mb-[128px] lg:gap-y-[128px]">
        <IskraWork collection={exhibition.Collections?.[0] ?? undefined} />
        <LarsWork collection={exhibition.Collections?.[1] ?? undefined} />
        <ZachWork collection={exhibition.Collections?.[2] ?? undefined} />
      </div>
    </div>
  )
}
